export function getDisplayName(subjectType: string, displayName: string): string {
  // If there is no display name then default to using subject type
  if (displayName == null || displayName.trim() === '') {
    return subjectType;
  }
  return displayName;
}
